import axios from 'axios';
import DIContainer from './di.container';
import DITYPES from './di.types';
import GlobalErrorHandlerService from '../services/GlobalErrorHandlerService';
import NotificationService from '../services/NotificationService';
import EventEmitter from "../config/event.emitter";
import { snackBarClose } from '../common/constant';

const errorHandlingService = DIContainer.get<GlobalErrorHandlerService>(DITYPES.GlobalErrorHandlerService);
const notificationService = DIContainer.get<NotificationService>(DITYPES.NotificationService);

axios.interceptors.request.use((config) => {
  notificationService.notifySnackbarClose();
  let configuration = config;
  if (!configuration) {
    configuration = { headers: setDefaultHeaders };
  }

  configuration.headers = {
    ...configuration.headers,
  };

  notificationService.notifyProgressSpinner(true); 
  
  return configuration;
}, (error) => {
  notificationService.notifyProgressSpinner(false);
  errorHandlingService.handleError(error, null);
});

axios.interceptors.response.use((respone) => {
  notificationService.notifyProgressSpinner(false);

  return respone;
},(error) => {
  notificationService.notifyProgressSpinner(false); 
  if(error.response) {
    errorHandlingService.handleError(error, null);
  }
});

var setDefaultHeaders = (): Headers => {
  let headers = new Headers();
  headers.append('Content-Type', 'application/json');
  headers.append('Accept', 'application/json');
  headers.append('Access-Control-Allow-Origin', '*');
  headers.append('mode', 'no-cors');
  headers.append('credentials', 'omit');
  return headers;
}

window.onunhandledrejection = function (error) {
  notificationService.notifyProgressSpinner(false);
  errorHandlingService.handleError(null, error);
};
